import { render, staticRenderFns } from "./assembleOrdersInfo.vue?vue&type=template&id=98f0f83e&"
import script from "./assembleOrdersInfo.vue?vue&type=script&lang=js&"
export * from "./assembleOrdersInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports